import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginForm from "./login-form";
import LayoutLogin from "./layout/LayoutLogin";
import ForgotPassword from "./modal/ForgotPasswordModal";
import Button from "../../../shared/button";


const Login = () => {
    const navigate = useNavigate()
    const [showForgotPasswordModal, setShowForgotPasswordModal] = useState<boolean>(false)

    const onShowHideForgotPassword = () => {
        setShowForgotPasswordModal(!showForgotPasswordModal)
    }

    return (
        <LayoutLogin>
            <div className='min-w-[100%] min-h-full flex flex-col justify-center md:justify-between'>
                {/* <NavLink to="/"> */}
                {/* Logo here */}
                {/* <img className="max-w-[290px]" alt="for the earth" src="/logo/logo.svg" /> */}
                {/* </NavLink> */}
                <div className="m-auto min-w-[350px]">
                    <h1 className="font-dm_sans_bold text-4xl text-[#0E0F0C]">Log in</h1>
                    <LoginForm />
                    <div className="font-dm_sans_regular text-center flex flex-col items-center mt-8">
                        <Button
                            label={'Forgot your password?'}
                            className={'btn-primary-text !font-normal'}
                            onClickButton={onShowHideForgotPassword}
                        />
                        {/* <div className="my-5 min-w-[70%] border border-borderColor"></div>
                    <Button
                        label={'I don’t have an account.'}
                        className={'btn-primary-text !font-normal'}
                        onClickButton={() => navigate('/register')}
                    /> */}
                    </div>
                </div>
                <ForgotPassword
                    openForgotModal={showForgotPasswordModal}
                    handleCloseForgotModal={onShowHideForgotPassword}
                />
            </div>
        </LayoutLogin>
    )
}

export default Login;